import { getAccentColor as getGlobalAccentColor } from './global';
import { DATA_STATE_CHECKED, DATA_STATE_INDETERMINATE, INTERACTION_STATE_HOVER, } from '../../../../constants';
export function getAccentColor(transformer) {
    const globalAccentColor = getGlobalAccentColor(transformer);
    return Object.freeze({
        form: {
            radioButton: {
                default: { value: globalAccentColor.gray600 },
                dataStates: {
                    [DATA_STATE_CHECKED]: { value: globalAccentColor.mediumOrange600 },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalAccentColor.gray1000 },
                },
            },
            checkbox: {
                default: { value: globalAccentColor.gray600 },
                dataStates: {
                    [DATA_STATE_CHECKED]: { value: globalAccentColor.mediumOrange600 },
                    [DATA_STATE_INDETERMINATE]: {
                        value: globalAccentColor.mediumOrange600,
                    },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalAccentColor.gray1000 },
                },
            },
        },
    });
}
